import { all, takeEvery, put, call } from 'redux-saga/effects';
import actions from './actions';
import { getList, addData } from '../../helpers/fackBackend_Helper';

function* getLockedActivationRequestListResponse() {
    try {
        const response = yield call(getList, '/lockedActivationRequest');
        if (response.response.Status) {
            yield put(actions.getLockedActivationRequestSuccess(response.response.Data));
        } else {
            yield put(actions.getLockedActivationRequestFailed(response.response.Message));
        }
    } catch (error) {
        yield put(actions.getLockedActivationRequestFailed(error));
    }
}

function* getLockedDailyPlanActivationListResponse() {
    try {
        const response = yield call(getList, '/lockedDailyPlanActivation');
        if (response.response.Status) {
            yield put(actions.getLockedDailyPlanActivationSuccess(response.response.Data));
        } else {
            yield put(actions.getLockedDailyPlanActivationFailed(response.response.Message));
        }
    } catch (error) {
        yield put(actions.getLockedDailyPlanActivationFailed(error));
    }
}

function* getLockedSimSwapRequesttListResponse() {
    try {
        const response = yield call(getList, '/lockedSIMSwapRequest');
        if (response.response.Status) {
            yield put(actions.getLockedSIMSwapRequestSuccess(response.response.Data));
        } else {
            yield put(actions.getLockedSIMSwapRequestFailed(response.response.Message));
        }
    } catch (error) {
        yield put(actions.getLockedSIMSwapRequestFailed(error));
    }
}

function* getReleseActivationRequestReponse({ payload: { unLockData } }) {
    try {
        const response = yield call(addData, '/releaseActivationRequest/', unLockData);
        if (response.lockData[0].Status) {
            yield put(actions.releaseActivationRequestSuccessful(response.lockData[0].Message));
            yield put(actions.getLockedActivationRequest());
        } else {
            yield put(actions.releaseActivationRequestFailed(response.lockData[0].Message));
        }
    } catch (error) {
        yield put(actions.releaseActivationRequestFailed(error));
    }
}

function* getReleseDailyPlanRequestReponse({ payload: { unLockData } }) {
    try {
        const response = yield call(addData, '/releaseDailyPlanRequest/', unLockData);
        if (response.lockData[0].Status) {
            yield put(actions.releaseDailyPlanRequestSuccessful(response.lockData[0].Message));
            yield put(actions.getLockedDailyPlanActivation());
        } else {
            yield put(actions.releaseDailyPlanRequestFailed(response.lockData[0].Message));
        }
    } catch (error) {
        yield put(actions.releaseDailyPlanRequestFailed(error));
    }
}

function* getReleseSIMSwapRequestReponse({ payload: { unLockData } }) {
    try {
        const response = yield call(addData, '/releaseSIMSWwapRequest/', unLockData);
        if (response.lockData[0].Status) {
            yield put(actions.releaseSIMSwapRequestSuccessful(response.lockData[0].Message));
            yield put(actions.getLockedSIMSwapRequest());
        } else {
            yield put(actions.releaseSIMSwapRequestFailed(response.lockData[0].Message));
        }
    } catch (error) {
        yield put(actions.releaseSIMSwapRequestFailed(error));
    }
}

export default function* rootSaga() {
    yield all([takeEvery(actions.GET_LOCKED_ACTIVATION_REQUEST, getLockedActivationRequestListResponse)]);
    yield all([takeEvery(actions.GET_LOCKED_DAILY_PALN_ACTIVATION, getLockedDailyPlanActivationListResponse)]);
    yield all([takeEvery(actions.GET_LOCKED_SIM_SWAP_REQUEST, getLockedSimSwapRequesttListResponse)]);
    yield all([takeEvery(actions.RELESE_ACTIVATION_REQUEST, getReleseActivationRequestReponse)]);
    yield all([takeEvery(actions.RELESE_DAILY_PLAN_REQUEST, getReleseDailyPlanRequestReponse)]);
    yield all([takeEvery(actions.RELESE_SIM_SWAP_REQUEST, getReleseSIMSwapRequestReponse)]);

}